export default function Impressum() {
  return (
    <div className="min-h-screen bg-[#F8F9FA] py-12">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <h1 className="font-barlow font-bold text-3xl text-[#1A1A1A] mb-8">
          Impressum
        </h1>
        
        <div className="prose prose-gray max-w-none font-manrope">
          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <p className="text-gray-600">
              FarbWelt Maler Express Service UG (Haftungsbeschränkt)<br />
              Gneisenaustr. 2<br />
              41539 Dormagen<br />
              Deutschland
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              Kontakt
            </h2>
            <p className="text-gray-600">
              Telefon: 02133 7787688<br />
              E-Mail: kontakt@farbwelt-service.de
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              Berufsbezeichnung und berufsrechtliche Regelungen
            </h2>
            <p className="text-gray-600">
              Berufsbezeichnung: Maler<br />
              Zuständige Kammer: Handwerkskammer Düsseldorf<br />
              Verliehen in: Deutschland
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              EU-Streitschlichtung
            </h2>
            <p className="text-gray-600">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr" className="text-[#9B1B30] hover:underline ml-1">
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              Verbraucherstreitbeilegung/Universalschlichtungsstelle
            </h2>
            <p className="text-gray-600">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              Haftung für Inhalte
            </h2>
            <p className="text-gray-600">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
              Tätigkeit hinweisen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              Urheberrecht
            </h2>
            <p className="text-gray-600">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
              Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
